import React from "react";
import { useState, useRef, useEffect } from "react";

export const BsCheckBox = ({value, setValue, onChange}) => {
	const onChangeValue = (e) => {
		setValue?.(e.target.checked);
		onChange?.(e);
	};

	return (
		<input type="checkbox" className="form-check-input" checked={value} onChange={onChangeValue}/>
	);
};

export const BsCheckBoxLabel = ({name, value, setValue, onChange, formSize}) => {
	const onChangeValue = (e) => {
		setValue?.(e.target.checked);
		onChange?.(e);
	};

	return (
		<div className="form-check d-flex align-items-center p-0 gap-1">
			<input type="checkbox" className={`form-check-input ${formSize ?? "form-select-lg"} p-0 m-0`} checked={value} onChange={onChangeValue}/>
			<label className="form-check-label">{name}</label>
		</div>
	);
};

export const BsSelectBox = ({itemList, value, setValue, onChange, formSize, style}) => {
	const onChangeValue = (e) => {
		setValue?.(e.target.value);
		onChange?.(e);
	};

	return (
		<select
			className={`form-select ${formSize ?? "form-select-sm"} w-auto`}
			disabled={(itemList.length == 0)}
			value={value}
			onChange={onChangeValue}
			style={style}
		>
			{itemList.map((item, index) => (
				<option key={index} value={item}>{item}</option>
			))}
		</select>
	);
};

export const BsSelectBoxLabel = ({name, itemList, value, setValue, onChange, formSize}) => {
	const onChangeValue = (e) => {
		setValue?.(e.target.value);
		onChange?.(e);
	};

	return (
		<div className="d-flex gap-1 align-items-center">
			<div className="flex-shrink-0">{name}</div>
			<select className={`form-select ${formSize ?? "form-select-sm"} w-auto`} disabled={(itemList.length == 0)} value={value} onChange={onChangeValue}>
				{itemList.map((item, index) => (
					<option key={index} value={item.value}>{item.text}</option>
				))}
			</select>
		</div>
	);
};

export const BsInput = ({placeholder, value, setValue, formSize}) => {
	const [text, setText] = useState(value);
	const composingRef = useRef(false);

	useEffect(() => {
		setText(value);
	}, [value]);

	return (
		<input
			type="text"
			className={`form-control ${formSize ?? "form-control-sm"} flex-grow-1`}
			placeholder={placeholder}
			value={text}
			onChange={(e)=> {setText(e.target.value);}}
			maxLength="400"
			onCompositionStart={() => {
				composingRef.current = true;
			}}
  			onCompositionEnd={() => {
				composingRef.current = false;
			}}
			onBlur={() => {
				if (value != text) {
					setValue(text);
				}
			}}
			onKeyDown={(e) => {
				if (composingRef.current) {
					return;
				}

				if (e.key === "Enter") {
					e.preventDefault();// フォーム送信防止
					e.currentTarget.blur();
				}
				else if (e.key === "Escape") {
					setText(value);
					e.preventDefault();
					e.currentTarget.blur();
				}
			}}
		/>
	);
};

export const BsInputLabel = ({name, placeholder, value, setValue, formSize}) => {
	const [text, setText] = useState(value);
	const composingRef = useRef(false);

	useEffect(() => {
		setText(value);
	}, [value]);

	return (
		<div className="d-flex gap-1 align-items-center">
			<label className="flex-shrink-0">{name}</label>
			<input
				type="text"
				className={`form-control ${formSize ?? "form-control-sm"} flex-grow-1`}
				placeholder={placeholder}
				value={text}
				onChange={(e)=> {setText(e.target.value);}}
				maxLength="100"
				onCompositionStart={() => {
					composingRef.current = true;
				}}
  				onCompositionEnd={() => {
					composingRef.current = false;
				}}
				onBlur={() => {
					if (value != text) {
						setValue(text);
					}
				}}
				onKeyDown={(e) => {
					if (composingRef.current) {
						return;
					}

					if (e.key === "Enter") {
						e.preventDefault();// フォーム送信防止
						e.currentTarget.blur();
					}
					else if (e.key === "Escape") {
						setText(value);
						e.preventDefault();
						e.currentTarget.blur();
					}
				}}
			/>
		</div>
	);
};

export const BsTextArea = ({name, placeholder, value, setValue, onChange, rows=4, maxLength=400, formSize}) => {
	return (
		<div className="d-flex gap-1 align-items-center">
			<label className="flex-shrink-0">{name}</label>
			<textarea
				type="text"
				className={`form-control ${formSize ?? "form-control-sm"} flex-grow-1`}
				placeholder={placeholder}
				value={value}
				onChange={(e)=> {
					setValue?.(e.target.value);
					onChange?.(e);
				}}
				rows={rows}
				maxLength={maxLength}
			/>
		</div>
	);
};